import { useState, useEffect } from 'react';
import { useAxios } from '../core/_axios';
import useReceivedEmailsWebSocket from './useReceivedEmailsWebSocket';

interface EmailCountResponse {
  unread_count: number;
}

export const useReceivedEmailsCount = () => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const axios = useAxios();

  // Use WebSocket for real-time updates
  useReceivedEmailsWebSocket({
    onEmailCreated: (email) => {
      if (email.status === 'unread') {
        setUnreadCount(prev => prev + 1);
      }
    },
    onEmailUpdated: (email) => {
      // This will be handled by the onUnreadCountChanged callback
    },
    onUnreadCountChanged: (count) => {
      setUnreadCount(count);
    }
  });

  const fetchCount = async () => {
    try {
      const response = await axios.get('/authenticated/current-account/received-emails?page=1&per_page=1');
      const data = response.data as EmailCountResponse;
      setUnreadCount(data.unread_count || 0);
    } catch (error) {
      console.error('Failed to fetch email count:', error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch
    fetchCount();
  }, []);

  return { unreadCount, loading, refetch: fetchCount };
};

export default useReceivedEmailsCount;